import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from '@material-ui/core';
import EmptyPlaceholder from 'components/EmptyPlaceholder/EmptyPlaceholder';
import LoadingSpinner from 'components/LoadingSpinner';
import { IconAccessCode } from 'icons';
import { useMemo, useState } from 'react';
import { useGetAccessCodesQuery } from '../accessSlice';
import AccessCodeView from './AccessCodeView';
import { AccessCodeListStyle } from './style';

const AccessCodeList = ({ accessGroup, vehicleId = undefined, btnStyle = 'outlined' }) => {
    const classes = AccessCodeListStyle()

    const [dialogOpen, setDialogOpen] = useState(false);

    let { data: accessCodes, error, isLoading } = useGetAccessCodesQuery(accessGroup?.id, { skip: !dialogOpen });

    const accessCodeData = useMemo(() => {
        if (!accessCodes) return [];
        let data = accessCodes.map(a => ({ ...a?.lot, lotName: a?.lot?.name, ...a }));
        return vehicleId
            ? data.filter(a => a.vehicleId == vehicleId) 
            : data.filter(a => a.vehicleId == null);
    }, [accessCodes, vehicleId]);

    const vehicleLookup = accessGroup?.vehicles?.reduce((map, vehicle) => {
        map[vehicle.id] = vehicle;
        return map;
    }, {});

    return (
        <>
            <Button
                variant={btnStyle}
                color="primary"
                startIcon={<IconAccessCode width={20} className={classes.icon} />}
                onClick={() => setDialogOpen(true)}
            >
                View Access Codes
            </Button>
            <Dialog
                open={dialogOpen}
                onClose={() => setDialogOpen(false)}
                fullWidth
                maxWidth='sm'>
                <DialogTitle>{`Access Codes For ${vehicleId ? 'Vehicle' : 'Group'}`}</DialogTitle>
                <DialogContent>
                    {!accessCodeData?.length && !isLoading && <EmptyPlaceholder text='No Access Codes Found' />}
                    <LoadingSpinner loading={isLoading} />
                    {accessCodeData?.map((accessCode, index) =>
                        <AccessCodeView accessCode={accessCode} vehicle={vehicleLookup[accessCode.vehicleId]} key={index} />)}
                </DialogContent>
                <DialogActions>
                    <Button
                        color="primary"
                        variant="outlined"
                        onClick={() => setDialogOpen(false)}>
                        Close
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    );
}

export default AccessCodeList;